import { render } from "./ServersTable.vue?vue&type=template&id=7382d7fa"
import script from "./ServersTable.vue?vue&type=script&lang=ts"
export * from "./ServersTable.vue?vue&type=script&lang=ts"

import "./ServersTable.vue?vue&type=style&index=0&id=7382d7fa&lang=css"
script.render = render

export default script